import { ReactNode } from 'react';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

type ModalHeaderProps = {
  title: ReactNode;
  onClose: () => void;
  disabled?: boolean;
  className?: string;
  closeClassName?: string;
};

export function ModalHeader({
  title,
  onClose,
  disabled = false,
  className = '',
  closeClassName = '',
}: ModalHeaderProps) {
  const { t } = useTranslation();

  return (
    <div className={`flex items-start justify-between gap-3 ${className}`}>
      <div className="flex-1 min-w-0">
        {typeof title === 'string' ? (
          <h3 className="text-lg font-semibold text-textPrimary">{title}</h3>
        ) : (
          title
        )}
      </div>
      <button
        type="button"
        onClick={onClose}
        disabled={disabled}
        aria-label={t('common.close')}
        className={`modal-close-btn shrink-0 p-1.5 -mr-1.5 -mt-0.5 rounded-lg text-textSecondary hover:text-textPrimary transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${closeClassName}`}
      >
        <X className="w-5 h-5" />
      </button>
    </div>
  );
}
